/**
 * 万药城客户端
 * @Description: 注册及认证模块
 */

export default [
    {
        path: "/frontPage/register",
        name: "register",
        component: () => import("@/pages/frontPage/register/register")
    },
    {
        path: "/frontPage/registerSuccess",
        name: "registerSuccess",
        component: () =>
            import("@/pages/frontPage/registerSuccess/registerSuccess")
    },
    {
        path: "/frontPage/authentication",
        name: "authentication",
        component: () =>
            import("@/pages/frontPage/authentication/authentication")
    },
    {
        path: "/frontPage/auditFail",
        name: "auditFail",
        component: () => import("@/pages/frontPage/auditFail/auditFail")
    },
    {
        path: "/frontPage/login",
        name: "login",
        component: () => import("@/pages/frontPage/login/login")
    },
    {
        path: '/frontPage/resetPassword',
        name: 'resetPassword',
        component: () => import('@/pages/frontPage/register/reset')
    }
];



// WEBPACK FOOTER //
// ./src/router/frontPage.js